var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui middle aligned grid content-view"},[_c('div',{staticClass:"ui row"},[_c('DIV',{staticClass:"ui column"},[(!_vm.checkpoint)?_c('CoverPage',{attrs:{"course":_vm.course}}):_c('CheckpointView',{attrs:{"checkpoint":_vm.checkpoint}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a59a88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentContainer.vue
// module id = 247
// module chunks = 0